/* eslint-disable */
import { tns } from 'tiny-slider/src/tiny-slider'

export default {
  init() {

    if(jQuery(".fullwidth-slider").length > 0) {
      tns({
            container: '.fullwidth-slider',
            fixedWidth: 400,
            slideBy: 1,
            controls: true,
            autoplayButton: false,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            nav: false,
            autoplay: true,
            lazyload: true,
            gutter: 15,
            controlsContainer: '#customize-controls',
            responsive: {
              360: {
                items: 1,
              },
              500: {
                items: 2,
              },
              768: {
                items: 3,
              },
              1000: {
                items: 4,
              },
              1100: {
                items: 4,
              },
            },
          });
        }

        if (typeof google !== 'undefined' && jQuery("#map").length > 0) {
          var styledMapType = new google.maps.StyledMapType(
          [
            {
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#bdbdbd"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#dadada"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "transit.line",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "transit.station",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#c9c9c9"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            }
          ],
          {name: 'Styled Map'});

          var markerPoint = {lat: parseFloat(document.querySelector("[data-map-lat]").dataset.mapLat), lng: parseFloat(document.querySelector("[data-map-lat]").dataset.mapLng)};

          var map = new google.maps.Map(document.getElementById('map'), {
                    center: markerPoint,
                    zoom: 12,
                    mapTypeControl: false,
                    panControl: false,
                    zoomControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    overviewMapControl: false,
                    rotateControl: false,
                    fullscreenControl: false
                  });

                  //Associate the styled map with the MapTypeId and set it to display.
                  map.mapTypes.set('styled_map', styledMapType);
                  map.setMapTypeId('styled_map');

          var marker = new google.maps.Marker({position: markerPoint, map: map});
        }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js